const STORAGE_KEY = 'sim_cookie_consent';
export const CONSENT_VERSION = '1';

export const getStoredConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (parsed.version !== CONSENT_VERSION) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const hasAnsweredConsent = () => getStoredConsent() !== null;

export const isAnalyticsGranted = () => {
  const consent = getStoredConsent();
  return consent?.analytics === true;
};

export const saveConsent = ({ analytics }) => {
  const record = {
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString(),
    analytics: Boolean(analytics)
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  window.dispatchEvent(new CustomEvent('cookie-consent-changed', { detail: record }));
  return record;
};

export const acceptAllCookies = () => saveConsent({ analytics: true });

export const rejectNonEssentialCookies = () => saveConsent({ analytics: false });
